import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../ContextAuth/Context";
import { Currencies } from "../Components/Currencies";
import { Data } from "../PaymentMethods/Data";
import { DirectTradeForm } from "./DirectTradeForm";
import { useOutletContext } from "react-router-dom";
import { getToken } from "../utils";

export const DirectBuy = () => {
  const { token: userToken } = getToken();

  const { selectedNavlink } = useOutletContext();

  return (
    <div className="lg:px-6">
      <DirectTradeForm transactionType={{ selectedNavlink }} />
    </div>
  );
};
